import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, Button } from '../../ui';
import { Body, Text } from '../../Common/Form';
import Continue from "../../Common/Continue";
import {
  setAPersonalValue,
} from "../../../actions";
import {
  ageBetween,
  numberBetween
} from "../../../helpers";

class APForm_3 extends Component {

  constructor(props) {
    super(props);
    this.state = { continue: false };
    this.legalHeirContent = this.legalHeirContent.bind(this);
    this.beneficiariesContent = this.beneficiariesContent.bind(this);
    this.continueCondition = this.continueCondition.bind(this);
  }

  componentDidMount() {
    this.checkContinueState(null);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const {
      legalHeir
    } = this.props;

    return (
      legalHeir ||
      (
        !legalHeir &&
        this.validateBeneficiaries()
      )
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }
  
  validateBeneficiariesPercentage() {
    const { beneficiaries } = this.props;
    let total = 0;

    beneficiaries.map((benef) => {
      total = total + parseInt(benef.Percentage, 0);
    })

    return total === 100;
  }

  isUnderAge(age) {
    return (parseInt(age, 0) < 18);
  }

  validateBeneficiaries() {
    const { beneficiaries } = this.props;
    let allOk = true;

    beneficiaries.map((benef) => {
      allOk = allOk &&
              benef.FullName &&
              benef.Document && benef.Document.length == 8 &&
              benef.Age && ageBetween(benef.Age, 0, 110) &&
              benef.Percentage &&
              (!this.isUnderAge(benef.Age) || 
                (
                  this.isUnderAge(benef.Age) &&
                  benef.ResponsiblePerson
                )
              );
    })

    return allOk && this.validateBeneficiariesPercentage();
  }

  legalHeirContent() {

    const {
      legalHeir,
      onAPersonalValueChange
    } = this.props;

    return (
      <div className="APersonales-checks">
        <Text className={`APersonales-option-text ${!legalHeir ? 'APersonales-option-off' : ''}`}>
          ¿Existen herederos legales?
        </Text>
        <div className="APersonales-options-check">
          <div className="APersonales-option-check">
            <label className={`${!legalHeir ? 'APersonales-option-off' : ''}`} htmlFor="yes"> <span>Si</span>
              <div className={`APersonales-radioWrapper ${legalHeir ? 'APersonales-radioWrapper--on' : ''}`}>
                <input 
                  type="radio" 
                  name="legalHeir" 
                  id="yes" 
                  value="true" 
                  checked={legalHeir}
                  onChange={() => { onAPersonalValueChange('legalHeir', true) }} 
                />
              </div>
            </label>
          </div>
          <div className="APersonales-option-check">
            <label className={`${!legalHeir ? 'APersonales-option-off' : ''}`} htmlFor="no"> <span>No</span>
              <div className={`APersonales-radioWrapper ${!legalHeir ? 'APersonales-radioWrapper--on' : ''}`}>
                <input 
                  type="radio" 
                  name="legalHeir" 
                  id="no" 
                  value="false" 
                  checked={!legalHeir}
                  onChange={() => { onAPersonalValueChange('legalHeir', false) }} 
                />
              </div>
            </label>
          </div>
        </div>
      </div>
    );
  };

  beneficiariesContent() {

    const {
      showError,
      legalHeir,
      beneficiaries,
      onBeneficiariesLengthChange
    } = this.props;

    return (
      <>
        <div className="APersonales-buttons">
          <Text className='APersonales-buttons-text'>
            Agregar beneficiarios
          </Text>
          <Button plain 
            className='APersonales-buttons-button'
            disabled={beneficiaries.length > 9}
            onClick={() => onBeneficiariesLengthChange(true, beneficiaries)}
            >+</Button>
          <Button plain 
            className='APersonales-buttons-button'
            onClick={() => onBeneficiariesLengthChange(false, beneficiaries)}
            disabled={beneficiaries.length < 2}
          >-</Button>
        </div>
        <div style={{ paddingTop: '25px'}}>
          {
            beneficiaries.map((benef, index) => {
              return this.beneficiariesRow(index);
            })
          }
        </div>
      </>
    );
  };

  beneficiariesRow(index) {

    const {
      showError,
      legalHeir,
      beneficiaries,
      onBeneficiariesChange
    } = this.props;

    const benef = beneficiaries[index];
    const totalOk = this.validateBeneficiariesPercentage();

    return (
      <div className="APersonales-beneficiaries-container overwrite-inputs">
        <div className="APersonales-beneficiaries-docu">
          <Input
            id="document"
            name="document"
            placeholder="Documento"
            type="number"
            value={benef.Document}
            onChange={(event) => { onBeneficiariesChange(index, event, beneficiaries, 8) }}
            showAlert={showError && (!benef.Document || benef.Document.length !== 8)}
            autoComplete="nope"
          />
        </div>
        <div className="APersonales-beneficiaries-name">
          <Input
            id="name"
            name="name"
            placeholder="Nombre y apellido"
            type="text"
            maxLength="50"
            value={benef.Fullname}
            onChange={(event) => { onBeneficiariesChange(index, event, beneficiaries, 50) }}
            showAlert={showError && !benef.FullName}
            autoComplete="nope"
          />
        </div>
        <div className="APersonales-beneficiaries-date">
          <Input
            id="age"
            name="age"
            placeholder="Edad"
            type="number"
            value={benef.Age}
            onChange={(event) => { onBeneficiariesChange(index, event, beneficiaries, 3) }}
            showAlert={showError && (!benef.Age || !ageBetween(benef.Age, 0, 110))}
            autoComplete="nope"
          />
        </div>
        <div className="APersonales-beneficiaries-perc">
          <Input
            id="percent"
            name="percent"
            placeholder={!totalOk ? '% (*)' : '%'}
            type='number'
            style={!totalOk ? {'color': 'red'} : {}}
            value={benef.Percentage}
            onChange={(event) => { onBeneficiariesChange(index, event, beneficiaries, 3); }}
            showAlert={showError && !benef.Percentage}
            autoComplete="nope"
          />
        </div>
        { this.isUnderAge(benef.Age) &&
          <>
            <div className="APersonales-beneficiaries-text">
              <Text className="Text-detail">
                Este beneficiario es menor de edad. Por favor ingrese el nombre de la persona responsable del menor
              </Text>
            </div>
            <div className="APersonales-beneficiaries-cont">
              <Input
                id="responsible"
                name="responsible"
                placeholder="Beneficiario contingente"
                type="text"
                maxLength="50"
                value={benef.ResponsiblePerson}
                onChange={(event) => { onBeneficiariesChange(index, event, beneficiaries, 50) }}
                showAlert={showError && !benef.ResponsiblePerson}
                autoComplete="nope"
              />
            </div>
          </>
        }
      </div> 
    );
  };


  render() {

    const { continue: toContinue } = this.state;
    const {
      legalHeir,
    } = this.props;
    const totalOk = this.validateBeneficiariesPercentage();

    return (
      <div>
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          Completa los siguientes campos
        </Text>
        <Body columnContent={this.legalHeirContent} />
        { !legalHeir &&
          <>
            <Body columnContent={this.beneficiariesContent} />
            { !totalOk &&
              <Text style={{ paddingTop: '15px'}} className="Text-detail Text-error"> 
                * La suma de los porcentajes de todos los beneficiarios debe ser 100%
              </Text>
            }
          </>
        }
        <Text style={{ padding: '20px 50px 0px'}} className="Text-detail">
          Cada beneficiario recibirá un porcentaje del total contratado. Este monto puede ser diferente para cada beneciario, siempre que la suma final sea el 100%
        </Text>
        <Continue state={toContinue}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,
    
    legalHeir: state.apersonal.legalHeir,
    beneficiaries: state.apersonal.beneficiaries,
    benefLarge: state.apersonal.beneficiaries.length,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAPersonalValueChange: (type, value) => {
      dispatch(setAPersonalValue(type, value));
    },
    onBeneficiariesChange: (index, event, beneficiaries, maxLength) => {
      let current = [...beneficiaries]; 
      const { value, name } = event.target;
      const { length } = value;

      if(length <= maxLength) {
        switch (name) 
        {
          case "document":    current[index].Document = value;                break;
          case "name":        current[index].FullName = value;                break;
          case "age":         current[index].Age = parseInt(value, 0);        break;
          case "percent":     current[index].Percentage = parseInt(value, 0); break;
          case "responsible": current[index].ResponsiblePerson = value;       break;
        }
      } else return false;
      dispatch(setAPersonalValue('beneficiaries', current));
    },
    onBeneficiariesLengthChange: (add, beneficiaries) => {
      if(add) beneficiaries.push({Document: '', FullName: '', Age: 0, Percentage: 0, ResponsiblePerson: ''});
      else    beneficiaries.pop();
      dispatch(setAPersonalValue('beneficiaries', beneficiaries));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(APForm_3);